import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { TreeTag } from '#domains/tags';

type Context = {
  expanded: boolean;
  filteredTags: TreeTag[];
  queryString: string;
  selectedIds: string[];
  setQueryString: Dispatch<SetStateAction<string>>;
  setSelectedIds: Dispatch<SetStateAction<string[]>>;
};

export const TreeTagsFilterContext = createContext<Context>({} as Context);
